/* eslint-disable indent */

import { t } from 'i18next'

import { pickNtbColumns } from '~/modules/retailMedia/helpers/ntbMetrics'

import { accountInfo } from '../../../_elements/accountInfo'
import { buildClickAttributionColumns } from '../../../_elements/roasColumns'
import { MetricTooltip } from '../../../../MetricMethodologyTooltip'
import { commonColumns } from '../columns'
import { campaignInfo } from '../elements/campaign'
import { cost } from '../elements/cost'
import { pickColumn, toggleValueByStatus } from '../helpers'

export const standardColumns = (params: SchemaProps) => {
  const columns = commonColumns(
    params?.availableMetrics,
    params?.showClickAlert,
    params?.campaignAdType,
    params?.lookbackMonths,
    params?.ntbOrdersWindow
  )

  const clickColumns = buildClickAttributionColumns(params?.showClickAlert)

  return {
    title: columns.title,
    status: columns.status,

    /**
     * Informações da conta vinculada se estiver fora da campanha
     */
    ...(params.isListAll ? { ...accountInfo() } : {}),

    /**
     * Informações da campanha se estiver fora da campanha
     */
    ...(!params.insideCampaign ? { ...campaignInfo } : {}),

    /**
     * CPC / CPM
     */
    ...cost({
      campaignAdType: params.campaignAdType,
      strategy: params.strategy,
      insideCampaign: params.insideCampaign
    }),

    /**
     * Métricas na mesma ordem das tabelas de Advertiser, Publisher e Campaign
     */
    impressions: columns.impressions,
    views: columns.views,
    clicks: columns.clicks,
    ctr: columns.ctr,
    totalSpent: columns.totalSpent,
    conversion: columns.conversion,
    conversionsClick: {
      ...clickColumns.conversionsClick,
      optional: true,
      helpContent: <MetricTooltip metric="conversionsClick" />,
      render: (rowData: AdsResultFormatted) =>
        toggleValueByStatus(rowData.status, rowData.metrics.conversionsClick)
    },
    conversion_rate: columns.conversion_rate,
    conversionRateClick: {
      ...clickColumns.conversionRateClick,
      optional: true,
      helpContent: <MetricTooltip metric="conversionRateClick" />,
      render: (rowData: AdsResultFormatted) =>
        toggleValueByStatus(rowData.status, rowData.metrics.conversionRateClick)
    },
    total_sales: columns.total_sales,
    salesClick: {
      ...clickColumns.salesClick,
      optional: true,
      helpText: t('rm:metrics.salesClick.tooltip'),
      render: (rowData: AdsResultFormatted) =>
        toggleValueByStatus(rowData.status, rowData.metrics.incomeClick)
    },
    total_conversions_items_quantity: columns.total_conversions_items_quantity,
    soldItemsClick: {
      ...clickColumns.soldItemsClick,
      optional: true,
      helpText: t('rm:metrics.SoldItemsClick.tooltip'),
      render: (rowData: AdsResultFormatted) =>
        toggleValueByStatus(
          rowData.status,
          rowData.metrics.totalConversionsItemsQuantityClick
        )
    },
    roas: columns.roas,
    roas_click: {
      ...clickColumns.roasClick,
      optional: true,
      helpContent: <MetricTooltip metric="roasClick" />,
      render: (rowData: AdsResultFormatted) =>
        toggleValueByStatus(rowData.status, rowData.metrics.roasClick)
    },
    roas_halo: columns.roas_halo,
    roas_overall: columns.roas_overall,
    halo_orders: columns.halo_orders,
    halo_revenue: columns.halo_revenue,
    halo_items: columns.halo_items,
    ...(params.availableMetrics?.impressionShare
      ? { impressionShare: columns.impressionShare }
      : {}),
    ...(params.availableMetrics?.lostIsRank
      ? { lostIsRank: columns.lostIsRank }
      : {}),
    ...pickColumn(
      params.availableMetrics?.lostIsBudget,
      'lostIsBudget',
      columns
    ),
    // commonColumns já filtrou pelas métricas disponíveis
    ...pickNtbColumns(columns)
  }
}
